var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5C6.675 5 5 6.675 5 8.745V41.1975C5 43.2675 6.6775 44.9425 8.75 44.9425H11.25C13.3175 44.9425 14.9975 43.2675 14.9975 41.1975V8.745C14.9975 6.675 13.3175 5 11.2475 5H8.7475H8.75ZM21.245 5C19.175 5 17.495 6.675 17.495 8.745V41.1975C17.495 43.2675 19.175 44.9425 21.245 44.9425H23.745C25.815 44.9425 27.4925 43.2675 27.4925 41.1975V8.745C27.4925 6.6775 25.815 5 23.7425 5H21.2425H21.245ZM39.295 15.3925C39.1808 14.8976 38.9672 14.4311 38.6673 14.0212C38.3673 13.6113 37.9872 13.2667 37.5501 13.0081C37.1129 12.7495 36.6278 12.5825 36.1241 12.5171C35.6204 12.4516 35.1087 12.4892 34.62 12.6275L32.7575 13.1525C31.8476 13.4098 31.0687 14.0017 30.5771 14.8095C30.0856 15.6173 29.9178 16.5811 30.1075 17.5075L35.115 42.005C35.2173 42.5015 35.4192 42.9722 35.7085 43.3885C35.9979 43.8048 36.3686 44.1581 36.7983 44.427C37.2281 44.696 37.7079 44.875 38.2088 44.9533C38.7096 45.0316 39.2212 45.0075 39.7125 44.8825L42.175 44.2575C44.15 43.7575 45.36 41.7725 44.905 39.79L39.295 15.39V15.3925Z",
    fill: "#155e8f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.867b141cad2ecdf22cd6fc8f4240c35e.svg";
export { ForwardRef as ReactComponent };